/**
 * AARKA Vibe Controller — Variant Color Vibe System
 * Manages CSS custom properties that change when a product variant is selected.
 * Reads vibe data from a JSON script tag and applies colors to the wrapper element.
 */
if (!customElements.get('aarka-vibe-controller')) {
  customElements.define('aarka-vibe-controller', class extends HTMLElement {
    connectedCallback() {
      this.vibeData = {};
      var dataEl = document.getElementById('aarka-vibe-data');
      if (dataEl) {
        try { this.vibeData = JSON.parse(dataEl.textContent); } catch(e) {}
      }

      // Listen to the theme's variant change event
      this._handler = this.onVariantChanged.bind(this);
      document.addEventListener('variant:changed', this._handler);

      // Also listen to the pub/sub pattern the theme uses
      if (typeof subscribe === 'function') {
        this._unsub = subscribe('variant_change', this.onPubSubVariant.bind(this));
      }
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this._handler);
      if (this._unsub) this._unsub();
    }

    onVariantChanged(e) {
      var variant = e.detail?.variant;
      if (variant) this.applyVibe(variant.id);
    }

    onPubSubVariant(e) {
      var variantId = e?.variant?.id;
      if (variantId) this.applyVibe(variantId);
    }

    applyVibe(variantId) {
      var vibe = this.vibeData[String(variantId)];
      if (!vibe) return;

      var props = ['bg', 'bg-secondary', 'accent', 'text', 'text-muted', 'shadow'];
      var keys = ['bg', 'bgSecondary', 'accent', 'text', 'textMuted', 'shadow'];

      for (var i = 0; i < props.length; i++) {
        var val = vibe[keys[i]];
        if (val) this.style.setProperty('--vibe-' + props[i], val);
      }
    }
  });
}
